<div class="panel panel-default">
    <div *ngIf="title" class="panel-heading">{{ title }}</div>
    <div [style.minHeight]="minHeight" [style.padding]="padding">
        <ng-content></ng-content>
    </div>
</div>